<template>
  <div>
    <selectAgent @changeActive="changeActive" v-if="active === 'agent'"/>
    <terminal-apply v-if="active === 'query'" :agentInfo="agentInfo" @changeActive="changeActive"  @back="backHome"/>
    <to-goods v-if="active === 'toGoods'" :agentInfo="agentInfo" :row-data="row" @back="back" sourceType="terminal" />
    <!-- <terminal-apply v-show="active === 'query'" @changeActive="changeActive" />
    <to-goods v-if="active === 'toGoods'" :row-data="row" @back="back" sourceType="terminal" /> -->
  </div>
</template>

<script>
import TerminalApply from './components/TerminalApply.vue'
import ToGoods from './components/ToGoods.vue'
import selectAgent from './components/selectAgent.vue'
export default {
  components: {
    ToGoods,
    TerminalApply,
    selectAgent
  },
  data() {
    return {
      active: 'agent',
      // active: 'query',
      row: {},
      agentInfo: {}
    }
  },
  created() {
    if (this.$route.query?.active === 'toGoods') {
      this.active = this.$route.query.active
    }
    if(this.$store.getters.role.ROLE != 'WLY027'){
      this.active = 'query'
    }
  },
  methods: {
    changeActive(type, row) {
      this.active = type
      if(type=='query'){
        this.agentInfo = row
        return
      }
      this.row = row
    },
    back() {
      if (this.$route.query?.id) {
        this.$router.back()
      } else {
        this.active = 'query'
      }
    },
    backHome() {
      this.active = 'agent'
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/terminalPlan.vue